import DOMPurify from 'dompurify';
import { useMemo } from 'react';

// Central sanitizer for every piece of CMS-authored HTML rendered by the app.
// Strips scripts, event handlers, and embedding tags; keeps formatting markup.
const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'form', 'input', 'button', 'iframe', 'object', 'embed', 'svg', 'math'],
  FORBID_ATTR: ['formaction'],
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    if (node.getAttribute('target') !== '_blank') node.removeAttribute('target');
  }
});

export default function HtmlContent({ html, className = '' }) {
  const clean = useMemo(() => (html ? DOMPurify.sanitize(html, SANITIZE_OPTIONS) : ''), [html]);
  if (!clean) return null;
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
